import React from "react";
import "./StudentExperience.css";

const StudentExperience = () => {
    const experiences = [
        {
            number: "01",
            title: "Learn in a Practical Environment",
            description:
                "Experience classroom learning with practical demonstrations, coding practice and mentor guidance.",
            image: "/images/Learning1.webp",
        },
        {
            number: "02",
            title: "Learn With Expert Instructors",
            description:
                "Get hands-on guidance from instructors while learning programming and software development concepts.",
            image: "/images/PlacementPrep1.webp",
        },
        {
            number: "03",
            title: "Get Personalised Mentorship",
            description:
                "Receive individual guidance, technical support and feedback throughout your learning journey.",
            image: "/images/Mentors1.webp",
        },
        {
            number: "04",
            title: "Prepare for Your Career",
            description:
                "Take part in placement preparation, communication activities, mock interviews and career guidance.",
            image: "/images/Instructors1.webp",
        },
    ];

    return (
        <section className="student-experience-section">

            {/* ================= HEADER ================= */}

            <div className="student-experience-header">

                <span className="student-experience-badge">
                    STUDENT EXPERIENCE
                </span>

                <h2>
                    Learn. Practice.
                    <span> Grow With PRT Academy.</span>
                </h2>

                <p>
                    Experience a practical learning environment where students
                    develop technical skills, work with mentors and prepare for
                    real career opportunities.
                </p>

            </div>


            {/* ================= EXPERIENCE CARDS ================= */}

            <div className="student-experience-grid">

                {experiences.map((item) => (

                    <article
                        className="student-experience-card"
                        key={item.number}
                    >

                        {/* IMAGE */}

                        <div className="student-experience-image-wrapper">

                            <img
                                src={item.image}
                                alt={item.title}
                                className="student-experience-image"
                            />

                            <span className="student-experience-number">
                                {item.number}
                            </span>

                        </div>


                        {/* CONTENT */}

                        <div className="student-experience-content">

                            <h3>
                                {item.title}
                            </h3>

                            <p>
                                {item.description}
                            </p>

                        </div>

                    </article>

                ))}

            </div>


            {/* ================= BOTTOM MESSAGE ================= */}

            <div className="student-experience-bottom">

                <div>

                    <span>
                        PRT ACADEMY
                    </span>

                    <h3>
                        Real Learning.
                        <strong> Real Practice. Real Growth.</strong>
                    </h3>

                </div>

                <p>
                    From classroom learning to career preparation, students
                    experience every stage of their professional journey.
                </p>

            </div>

        </section>
    );
};

export default StudentExperience;